import { Say2 } from "../widgets/Say2";
import { SayMandarin } from "./ConvertMandarin";
import { PinyinSymbol } from "./PinyinSamples";

/** show pinyin symbols, its IPA, sample pinyin, and a description */
export function PinyinLetters(props: {
  title: string,
  symbols: PinyinSymbol[],
}) {
  return (<>
    <h3>{props.title}</h3>
    <table>
      <thead>
        <tr>
          <th>pinyin</th>
          <th>IPA</th>
          <th>sample</th>
          <th>description</th>
        </tr>
      </thead>
      <tbody style={{ textAlign: 'left' }}>
        {props.symbols.map((symbol, i) => <LetterRows symbol={symbol} key={i} />)}
      </tbody>
    </table>
  </>);
}

/** show one or more rows with info about the letter & any sample words using it */
function LetterRows(props: { symbol: PinyinSymbol }) {
  return (<>
    <tr>
      <td>{props.symbol.symbols}</td>
      <td><Say2>{`/${props.symbol.ipa}/`}</Say2></td>
      <td><SayMandarin>{props.symbol.samplePinyin}</SayMandarin></td>
      <td>{props.symbol.desc}</td>
    </tr>
  </>);
}
